/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Wunschsprache_German6Inputs */

const en__field__enum_wunschsprache_german6 = /** @type {(inputs: _Field__Enum_Wunschsprache_German6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de__field__enum_wunschsprache_german6 = /** @type {(inputs: _Field__Enum_Wunschsprache_German6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {_Field__Enum_Wunschsprache_German6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_wunschsprache_german6 = /** @type {((inputs?: _Field__Enum_Wunschsprache_German6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Wunschsprache_German6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_wunschsprache_german6(inputs)
	return de__field__enum_wunschsprache_german6(inputs)
});
export { _field__enum_wunschsprache_german6 as "_field__enum_wunschsprache_GERMAN" }